import styled from 'styled-components'

export const Viewer = styled.div<{ hideBorder?: boolean }>`
  flex: 1;
  display: flex;

  ${({ hideBorder }) =>
    !hideBorder &&
    `
    border: 1px solid #bbc1d3;
    border-radius: 6px;
  `}

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    border: none;
    border-radius: unset;
  }
`
